import packagejson from "../../package.json";
import { commonValues } from "./common.values.for.all.environment";

export const environment = {
  ...commonValues,
  envName: "production",
  production: true,
  development: false,
  acceptance: false,
  version: packagejson.version,
  apiHost: "https://api.montreal.ca/api/public-works/operations",
  citizenApiHost: "https://api.montreal.ca/api/public-works/citizen-requests",
  tokenTranslatorApiHost:
    "https://api.montreal.ca/api/security/v1/token-translator",
  currentMapType: "WMTS",
  capabilities: {
    photosActive: true,
  },
  mapConfig: {
    centerLatLng: { lat: 45.5087, Lng: -73.554 },
    defaultZoom: 10,
    osm: {
      centerLatLng: { lat: 45.5087, Lng: -73.554 },
      zoom: 10,
      urlTemplate:
        "http://{s}.tile2.opencyclemap.org/transport/{z}/{x}/{y}.png",
      titleLayerOption: {
        attribution:
          'Map data © <a href="http://openstreetmap.org">OpenStreetMap</a> contributors',
        minZoom: 10,
        maxZoom: 21,
        bounds: {
          northWest: [45.7467203, -74.0688639],
          southEast: [45.3760139, -73.3194016],
        },
      },
    },
    wmts: {
      mapOptions: {
        center: [45.5087, -73.554],
        crs: null,
        zoom: 10,
        minZoom: 10,
        maxZoom: 20,
        popBubblesAtZoom: 16, // 16 = 100 meters
        zoomControl: false,
        maxBounds: {
          _southWest: { lat: 45.25652, lng: -74.16733 },
          _northEast: { lat: 45.80104, lng: -73.31726 },
        },
      },
      url: "https://api.montreal.ca/api/it-platforms/geomatic/raster-maps/v2/service/wmts?",
      titleLayerOption: {
        tilematrixSet: "EPSG:3857",
        style: "normal",
        format: "image/png",
        matrixIds: null,
        layer: "basemap3857",
        minZoom: 10,
        maxZoom: 21,
        attribution: "",
      },
      geolocalizationZoom: 17,
      mapBound: {
        southWest: [45.3984338, -73.990778],
        northEast: [45.7139284, -73.4474681],
      },
      scale: {
        isImperial: false,
      },
      zoomHome: {
        position: "topright",
      },
      staticMap: {
        staticMapZoom: 16,
        scrollWheelZoom: false,
        zoomControl: false,
        dragging: false,
      },
    },
  },
  oauthParameter: {
    redirectUri: "https://services.montreal.ca/app-contremaitre/",
    logoutUrl: "https://services.montreal.ca/app-contremaitre/",
    clientId: "@!4025.CA62.9BB6.16C5!0001!2212.0010!0008!2212.0860",
    scope: "profile+email+user_name openid",
    oidc: true,
    issuer: "https://auth.montreal.ca",
    loginUrl: "https://auth.montreal.ca/oxauth/restv1/authorize",
    customQueryParams: {
      ui_locales: "fr",
      acr_values: "basic_multi_auth_conf_emp",
    },
    mocked: {
      active: false,
    },
    showDebugInformation: false, // Also requires enabling "Verbose" level in devtools
    silentRefreshRedirectUri:
      "https://services.montreal.ca/app-contremaitre/assets/html/silent-refresh.html",
  },
  authBiMode: {
    defaultAuthVersionsCfgUrl: {
      employee: {
        version: "v1",
      },
      citizen: {
        version: "v1",
      },
    },
    authVersionsCfgUrl:
      "https://services.montreal.ca/.well-known/montreal-auth-config",
    citizenv2: {},
    citizenv1: {
      issuer: "https://auth.montreal.ca",
      clientId: "@!4025.CA62.9BB6.16C5!0001!2212.0010!0008!2212.0860",
      scope: "openid profile email user_name",
    },
    employeev2: {
      issuer: "https://login.microsoftonline.com/montreal.ca/v2.0",
      clientId: "63bcb6a0-0504-4743-8d66-968f422a3773",
      scope:
        "openid profile email 63bcb6a0-0504-4743-8d66-968f422a3773/.default",
      strictDiscoveryDocumentValidation: false,
      skipIssuerCheck: true,
      sessionChecksEnabled: false, // Not supported by Azure EntraID
    },
    employeev1: {
      // clientId: '@!4025.CA62.9BB6.16C5!0001!2212.0010!0008!A26F.8437.953D.943C',
      // issuer: "https://idp.montreal.ca",
      // loginUrl: "https://idp.montreal.ca/oxauth/restv1/authorize",
    },
  },
  apiRequestParameters: {
    httpTimeout: 200000,
    mock: false,
  },
  userExperience: {
    alwaysShowSpinnerEvenIfFast: false,
  },
};
